import DownloadIcon from '@mui/icons-material/Download';
import IosShareIcon from '@mui/icons-material/IosShare';
import { Box, Button } from '@mui/material';
import {
  FavouriteButton,
  type FavouriteButtonProps,
} from '@orcha/micro-library-core-ui';

export type ButtonsListProps = {
  favouriteButton?: FavouriteButtonProps;
  recommendButton?: DefaultButtonProps;
  downloadButton?: DefaultButtonProps;
};

type DefaultButtonProps = {
  onClick: () => void;
  label: string;
  title: string;
};

/**
 * ButtonsList component from [MicroLibraryAppDetailsUI](https://dev.azure.com/orcha/MicroLibraryTemplate/_git/MicroLibraryAppDetailsUI)
 * @param {ButtonsListProps} buttonsListProps - The props for the ButtonsList component
 * @returns {ReactElement} The ButtonsList component
 */

export const ButtonsList = ({
  favouriteButton,
  downloadButton,
  recommendButton,
}: ButtonsListProps) => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        gap: ({ spacing }) => spacing(1),
      }}
    >
      <Box
        sx={{
          display: 'flex',
          gap: ({ spacing }) => spacing(1),
          flexWrap: 'wrap',
        }}
      >
        {recommendButton && (
          <Button
            color="primary"
            variant="contained"
            startIcon={<IosShareIcon />}
            title={recommendButton.title}
            onClick={recommendButton.onClick}
            data-testid="app-details-recommend-button"
          >
            {recommendButton.label}
          </Button>
        )}

        {downloadButton && (
          <Button
            color="primary"
            variant="outlined"
            startIcon={<DownloadIcon />}
            title={downloadButton.title}
            onClick={downloadButton.onClick}
            data-testid="app-details-download-button"
          >
            {downloadButton.label}
          </Button>
        )}
      </Box>

      {favouriteButton && (
        <FavouriteButton
          testId="app-details-favourites-button"
          {...favouriteButton}
        />
      )}
    </Box>
  );
};
